export default {

  store(data, key) {
    if (!window.localStorage || !window.JSON || !key) {
      return;
    }
    localStorage.setItem(key, JSON.stringify(data));
  },

  get(key) {
    if (!window.localStorage || !window.JSON || !key) {
      return;
    }
    var item = localStorage.getItem(key);

    if (!item) {
      return;
    }

    return JSON.parse(item);
  },

  remove(key) {
    if (!window.localStorage || !window.JSON || !key) {
      return;
    }
    localStorage.removeItem(key);
  }
};
